import { e as escape_html, p as pop, a as push } from "../../../../chunks/index2.js";
import "clsx";
import "@sveltejs/kit/internal";
import "../../../../chunks/exports.js";
import "../../../../chunks/utils.js";
import "../../../../chunks/state.svelte.js";
import { g as getToastState } from "../../../../chunks/Toast.svelte.js";
function _page($$payload, $$props) {
  push();
  let { data } = $$props;
  getToastState();
  function formInput($$payload2) {
    $$payload2.out.push(`<form method="POST" class="mb-4 w-full">`);
    {
      $$payload2.out.push("<!--[!-->");
    }
    $$payload2.out.push(`<!--]--> <input type="email" name="email" placeholder="Please enter your email..." class="mb-2 w-full rounded-sm border px-3 py-2"/> <button type="submit" class="group bg-primary hover:bg-primary/90 flex w-full items-center justify-center rounded-md border p-2 text-white transition-colors hover:cursor-pointer">`);
    {
      $$payload2.out.push("<!--[!-->");
    }
    $$payload2.out.push(`<!--]--> Submit</button></form>`);
  }
  $$payload.out.push(`<div class="flex flex-col items-center justify-center p-4">`);
  if (data?.status === 200) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<h1 class="mb-4 text-center text-2xl font-bold text-green-600">${escape_html(data.message)}</h1> <p class="mb-6 text-center text-gray-700">Your email has been verified successfully.</p> <div class="flex justify-center"><a href="/login" class="bg-primary hover:bg-primary/90 inline-block rounded-sm px-4 py-2 text-white shadow-sm">Proceed to Login</a></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
    if (data?.error) {
      $$payload.out.push("<!--[-->");
      if (data.error === "Email already verified") {
        $$payload.out.push("<!--[-->");
        $$payload.out.push(`<h1 class="mb-4 text-center text-2xl font-bold text-blue-600">Email already verified</h1> <p class="mb-6 text-center text-gray-700">Your email address has already been verified.</p> <div class="flex justify-center"><a href="/login" class="bg-primary hover:bg-primary/90 inline-block rounded-sm px-4 py-2 text-white shadow-sm">Proceed to Login</a></div>`);
      } else {
        $$payload.out.push("<!--[!-->");
        if (data.error === "Token expired") {
          $$payload.out.push("<!--[-->");
          $$payload.out.push(`<h1 class="mb-4 text-center text-2xl font-bold text-red-600">Token Expired</h1> <p class="mb-4 text-center text-gray-700">The verification token has expired. Please enter your email to resend the verification email.</p> <div class="flex w-full flex-col items-center">`);
          formInput?.($$payload);
          $$payload.out.push(`<!----> <div class="w-full text-right"><a href="/"><button class="bg-primary hover:bg-primary/90 rounded-sm px-3 py-1 text-white">Go Home</button></a></div></div>`);
        } else {
          $$payload.out.push("<!--[!-->");
          if (data.error === "Token is required") {
            $$payload.out.push("<!--[-->");
            $$payload.out.push(`<h1 class="text-primary mb-4 text-center text-xl font-bold lg:text-2xl">Resend Verification Email</h1> <p class="mb-4 text-center text-gray-700">Please enter your email to resend the verification email.</p> <div class="flex w-full flex-col items-center">`);
            formInput?.($$payload);
            $$payload.out.push(`<!----> <div class="w-full text-right"><a href="/"><button class="bg-primary hover:bg-primary/90 rounded-sm px-3 py-1 text-white">Go Home</button></a></div></div>`);
          } else {
            $$payload.out.push("<!--[!-->");
            $$payload.out.push(`<h1 class="mb-4 text-center text-2xl font-bold text-red-600">Error</h1> <p class="mb-4 text-center text-gray-700">${escape_html(data.error)}</p> <div class="flex justify-center"><a href="/" class="bg-primary hover:bg-primary/90 inline-block rounded-sm px-4 py-2 text-white shadow-sm">Go Home</a></div>`);
          }
          $$payload.out.push(`<!--]-->`);
        }
        $$payload.out.push(`<!--]-->`);
      }
      $$payload.out.push(`<!--]-->`);
    } else {
      $$payload.out.push("<!--[!-->");
    }
    $$payload.out.push(`<!--]-->`);
  }
  $$payload.out.push(`<!--]--></div>`);
  pop();
}
export {
  _page as default
};
